// src/services/sessionIdService.js

import { db } from '../firebase';
import { collection, doc } from 'firebase/firestore';

/**
 * Create a Firestore-safe session ID for temporary uploads.
 */
export function createSessionId() {
  return doc(collection(db, '_')).id;
}
